// extracted by mini-css-extract-plugin
module.exports = {"copyright":"Copyright-module--copyright--1ariN","copyright__heart":"Copyright-module--copyright__heart--3ZZzn","copyright-menu":"Copyright-module--copyright-menu--Uj1h7"};